import { render, staticRenderFns } from "./OrderPurchaseEdit.vue?vue&type=template&id=744c160e&"
import script from "./OrderPurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./OrderPurchaseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports